import { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { trackContact } from "../pages/metaPixel";

function ViewPhoneButton({
  productId,
  sellerPhone,
  sellerId,
  cname,
  userId,
  variant = "simple",
  typePage = "default",
  img = "",
  title = "",
  price = 0,
}) {
  const [showPhone, setShowPhone] = useState(false);
  const navigate = useNavigate();

  function getUserData() {
    const userString = localStorage.getItem("USER");
    if (userString) {
      try {
        const userArr = JSON.parse(userString);
        if (userArr && userArr.length > 0) return userArr[0];
      } catch {
        return null;
      }
    }
    return null;
  }

  const insertPhoneView = async (type) => {
    try {
      const ipResponse = await axios.get("https://api.ipify.org?format=json");
      const ipData = ipResponse.data;
      const formData = new FormData();
      formData.append("entity_type", type + "-phone" + "-" + typePage);
      formData.append("entity_id", productId);
      formData.append("user_id", userId);
      formData.append("ip", ipData.ip);
      await axios.post("/pro/analytics/insert_phone_view.php", formData);
    } catch {}
  };

  const trackAndCheckLogin = async (contactType) => {
    if (!userId) {
      navigate("/login");
      return false;
    }
    const userData = getUserData();
    const contactDetails = {
      custom_quote_type: contactType,
      custom_content_title: title || "Unknown",
      custom_price: price || 0,
      custom_currency: "PKR",
      custom_content_sellerId: sellerId || "General",
      custom_cname: cname || "unknown",
      custom_typePage: typePage || "unknown",
      custom_user_id: userData?.id || "unknown",
      custom_user_name: userData?.name || "unknown",
      custom_user_city: userData?.city || "unknown",
    };
    trackContact(contactDetails);
    await insertPhoneView(contactType);
    return true;
  };

  const handleViewPhoneClick = async () => {
    if (!(await trackAndCheckLogin("view"))) return;
    setShowPhone(true);
  };

  const handleCallNow = async () => {
    if (!(await trackAndCheckLogin("call"))) return;
    window.location.href = `tel:0${sellerPhone}`;
  };

  const handleWhatsAppChat = async () => {
    if (!(await trackAndCheckLogin("chat"))) return;
    let whatsappText = "";
    if (productId && title && title.trim() !== "") {
      const productUrl = `${window.location.origin}/product?id=${productId}&s=${encodeURIComponent(title)}`;
      whatsappText =
        `Salam! We saw your product on Alahdeen and wanted to get in touch.\n\n` +
        `*Product:* ${title}\n` +
        (price && price !== 0
          ? `*Price:* PKR ${price.toLocaleString()}`
          : "*Price:* Please let us know the price") +
        `\n\nProduct Link: ${productUrl}` +
        `\n\nAlahdeen – Pakistan's Online B2B Marketplace`;
    } else {
      whatsappText =
        `Salam! I am interested in your store on Alahdeen and would like to get in touch.\n\n` +
        `Please provide more details.\n\n` +
        `Alahdeen – Pakistan's Online B2B Marketplace`;
    }
    const whatsappUrl = `https://wa.me/92${sellerPhone}?text=${encodeURIComponent(whatsappText)}`;
    window.open(whatsappUrl, "_blank");
  };

  const SellerInfoModal = () => (
    <>
      <div
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          width: "100vw",
          height: "100vh",
          backgroundColor: "rgba(0,0,0,0.5)",
          zIndex: 1050,
        }}
      />
      <div
        role="dialog"
        aria-modal="true"
        aria-labelledby="sellerInfoModalTitle"
        style={{
          position: "fixed",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          backgroundColor: "#fff",
          borderRadius: "16px",
          width: "90%",
          maxWidth: "400px",
          padding: "1rem 1.5rem",
          zIndex: 1060,
          boxShadow: "0 5px 15px rgba(0,0,0,0.3)",
        }}
      >
        <div
          style={{
            display: "flex",
            width: "100%",
            alignItems: "center",
            marginBottom: "1rem",
          }}
        >
          <h5
            id="sellerInfoModalTitle"
            className="main-heading-style"
            style={{ margin: 0, width: "100%" }}
          >
            Seller Info
          </h5>
          <button
            type="button"
            onClick={() => setShowPhone(false)}
            aria-label="Close Seller Info"
            style={{
              background: "none",
              border: "none",
              fontSize: "1.5rem",
              fontWeight: "bold",
              cursor: "pointer",
              lineHeight: 1,
            }}
          >
            &times;
          </button>
        </div>
        <div className="seller-info text-center">
          {cname && (
            <p
              style={{
                fontSize: "16px",
                color: "#1D1D1D",
                fontWeight: 500,
                marginBottom: "5px",
              }}
            >
              {cname}
            </p>
          )}
          {sellerPhone ? (
            <p
              style={{
                fontSize: "14px",
                color: "#1D1D1D",
                fontWeight: "bold",
                marginBottom: "8px",
              }}
            >
              Phone: 0{sellerPhone}
            </p>
          ) : (
            <p
              style={{
                fontSize: "14px",
                color: "#888",
                marginBottom: "8px",
              }}
            >
              No phone number available
            </p>
          )}
          <div className="d-flex justify-content-center gap-2 align-items-center flex-wrap">
            <button
              onClick={handleCallNow}
              className="btn btn-sm d-flex align-items-center justify-content-center"
              aria-label="Call Now"
              type="button"
              title="Call Now"
              style={{
                minWidth: "52px",
                backgroundColor: "#036770",
                color: "#d6eff2",
                border: "1px solid #036770",
                fontSize: "12px",
              }}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="18"
                height="18"
                fill="currentColor"
                viewBox="0 0 16 16"
                className="me-1"
              >
                <path d="M3.654 1.328a.678.678 0 0 1 .738-.086c.74.37 1.637 1.107 2.507 2.047.87.94 1.661 2.053 2.158 2.875a.678.678 0 0 1-.161.739L7.487 7.175a11.456 11.456 0 0 0 3.31 3.31l1.153-1.406a.678.678 0 0 1 .74-.162c.823.498 1.936 1.288 2.875 2.158.94.87 1.676 1.767 2.047 2.507a.678.678 0 0 1-.086.738l-2.222 2.223c-.329.33-.889.435-1.37.182C6.148 14.014 1.986 9.852 1.28 5.033c-.253-.48-.147-1.04.182-1.37l2.223-2.222z" />
              </svg>
              Call
            </button>
            <button
              onClick={() => navigate(`/companydetail/${sellerId}/${cname || ""}`)}
              className="btn btn-sm d-flex align-items-center justify-content-center"
              style={{
                backgroundColor: "#1A78B4",
                color: "#fff",
                fontWeight: 500,
                fontSize: "12px",
              }}
            >
              Estore
            </button>
          </div>
        </div>
      </div>
    </>
  );

  const CompactButtons = () => (
    <div className="mb-1 text-center">
      {showPhone && <SellerInfoModal />}

      
      <div
          className="d-flex align-items-center justify-content-center gap-2"
          style={{
            flexWrap: "nowrap",
            minHeight: "40px", // ensures container height for alignment
            marginTop: "auto" // pushes buttons to bottom if parent uses flex column
          }}
        >
        <button
          onClick={handleWhatsAppChat}
          className="btn btn-sm d-flex align-items-center justify-content-center"
          style={{
            minWidth: "52px",
            backgroundColor: "#25D366",
            color: "white",
            border: "1px solid #1DA955",
            fontSize: "12px",
          }}
          aria-label="WhatsApp"
          title="Send on WhatsApp"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="18"
            height="18"
            fill="currentColor"
            viewBox="0 0 16 16"
            className="me-1"
          >
            <path d="M13.601 2.326A7.802 7.802 0 0 0 8 0C3.582 0 0 3.582 0 8a7.964 7.964 0 0 0 1.128 4.12L0 16l4.068-1.064A7.964 7.964 0 0 0 8 16c4.418 0 8-3.582 8-8 0-2.13-.83-4.138-2.399-5.674zm-5.6 11.81a6.547 6.547 0 0 1-3.333-.899l-.238-.141-2.417.633.645-2.353-.155-.242A6.55 6.55 0 0 1 1.455 8c0-3.607 2.938-6.545 6.545-6.545S14.545 4.393 14.545 8 11.607 14.545 8 14.545zm3.698-5.373c-.2-.1-1.18-.58-1.364-.646-.183-.067-.317-.1-.45.1-.133.2-.517.646-.634.779-.117.133-.233.15-.433.05-.2-.1-.84-.31-1.6-.99-.59-.525-.99-1.17-1.11-1.37-.117-.2-.013-.31.088-.41.09-.089.2-.233.3-.35.1-.116.133-.2.2-.333.067-.133.033-.25-.017-.35-.05-.1-.45-1.087-.617-1.487-.162-.39-.33-.34-.45-.35l-.383-.008c-.133 0-.35.05-.533.25-.183.2-.7.683-.7 1.666s.717 1.933.817 2.067c.1.134 1.4 2.134 3.4 2.987.475.205.844.327 1.133.42.475.15.908.129 1.25.079.383-.058 1.18-.483 1.35-.95.167-.467.167-.867.117-.95-.05-.083-.183-.133-.383-.233z" />
          </svg>
          Chat
        </button>
        <button
          onClick={handleViewPhoneClick}
          className="btn btn-sm d-flex align-items-center"
          aria-label="View Phone Number"
          type="button"
          title="View Phone Number"
          style={{
            minWidth: "52px",
            backgroundColor: "#d6eff2",
            color: "#036770",
            border: "1px solid #036770",
            fontSize: "12px",
          }}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="18"
            height="18"
            fill="currentColor"
            viewBox="0 0 16 16"
            className="me-1"
          >
            <path d="M3.654 1.328a.678.678 0 0 1 .738-.086c.74.37 1.637 1.107 2.507 2.047.87.94 1.661 2.053 2.158 2.875a.678.678 0 0 1-.161.739L7.487 7.175a11.456 11.456 0 0 0 3.31 3.31l1.153-1.406a.678.678 0 0 1 .74-.162c.823.498 1.936 1.288 2.875 2.158.94.87 1.676 1.767 2.047 2.507a.678.678 0 0 1-.086.738l-2.222 2.223c-.329.33-.889.435-1.37.182C6.148 14.014 1.986 9.852 1.28 5.033c-.253-.48-.147-1.04.182-1.37l2.223-2.222z" />
          </svg>
          View
        </button>
      </div>
    </div>
  );

  const SimpleButtons = () => (
    <div className="mb-1 text-center">
      {showPhone && <SellerInfoModal />}
        <div className="d-flex mt-3 gap-1 flex-wrap">
        <button
          onClick={handleWhatsAppChat}
          className="btn btn-sm d-flex align-items-center justify-content-center"
          style={{
            backgroundColor: "#25D366",
            border: "1px solid #1DA955",
            color: "white",
            padding: "5px 11px",
            borderRadius: "5px",
            cursor: "pointer",
            fontWeight: "bold",
            minWidth: "49%",
            transition: "background-color 0.3s ease",
          }}
          aria-label="WhatsApp"
          title="Send on WhatsApp"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="18"
            height="18"
            fill="currentColor"
            viewBox="0 0 16 16"
            className="me-1"
          >
            <path d="M13.601 2.326A7.802 7.802 0 0 0 8 0C3.582 0 0 3.582 0 8a7.964 7.964 0 0 0 1.128 4.12L0 16l4.068-1.064A7.964 7.964 0 0 0 8 16c4.418 0 8-3.582 8-8 0-2.13-.83-4.138-2.399-5.674zm-5.6 11.81a6.547 6.547 0 0 1-3.333-.899l-.238-.141-2.417.633.645-2.353-.155-.242A6.55 6.55 0 0 1 1.455 8c0-3.607 2.938-6.545 6.545-6.545S14.545 4.393 14.545 8 11.607 14.545 8 14.545zm3.698-5.373c-.2-.1-1.18-.58-1.364-.646-.183-.067-.317-.1-.45.1-.133.2-.517.646-.634.779-.117.133-.233.15-.433.05-.2-.1-.84-.31-1.6-.99-.59-.525-.99-1.17-1.11-1.37-.117-.2-.013-.31.088-.41.09-.089.2-.233.3-.35.1-.116.133-.2.2-.333.067-.133.033-.25-.017-.35-.05-.1-.45-1.087-.617-1.487-.162-.39-.33-.34-.45-.35l-.383-.008c-.133 0-.35.05-.533.25-.183.2-.7.683-.7 1.666s.717 1.933.817 2.067c.1.134 1.4 2.134 3.4 2.987.475.205.844.327 1.133.42.475.15.908.129 1.25.079.383-.058 1.18-.483 1.35-.95.167-.467.167-.867.117-.95-.05-.083-.183-.133-.383-.233z" />
          </svg>
          Chat
        </button>
        <button
          onClick={handleViewPhoneClick}
          className="btn btn-sm d-flex align-items-center justify-content-center"
          aria-label="View Phone Number"
          type="button"
          title="View Phone Number"
          style={{
            backgroundColor: "#d6eff2",
            border: "1px solid #036770",
            color: "#036770",
            padding: "5px 11px",
            borderRadius: "5px",
            cursor: "pointer",
            fontWeight: "bold",
            minWidth: "49%",
            transition: "background-color 0.3s ease",
          }}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="18"
            height="18"
            fill="currentColor"
            viewBox="0 0 16 16"
            className="me-1"
          >
            <path d="M3.654 1.328a.678.678 0 0 1 .738-.086c.74.37 1.637 1.107 2.507 2.047.87.94 1.661 2.053 2.158 2.875a.678.678 0 0 1-.161.739L7.487 7.175a11.456 11.456 0 0 0 3.31 3.31l1.153-1.406a.678.678 0 0 1 .74-.162c.823.498 1.936 1.288 2.875 2.158.94.87 1.676 1.767 2.047 2.507a.678.678 0 0 1-.086.738l-2.222 2.223c-.329.33-.889.435-1.37.182C6.148 14.014 1.986 9.852 1.28 5.033c-.253-.48-.147-1.04.182-1.37l2.223-2.222z" />
          </svg>
          View
        </button>
      </div>
    </div>
  );

  if (variant === "compact") return <CompactButtons />;
  return <SimpleButtons />;
}

export default ViewPhoneButton;
